@if(isMainComponent){
<div class="surface-ground tw-flex tw-min-h-screen tw-min-w-full tw-overflow-hidden">
  <!-- Form pane -->
  <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-p-4">
    <div class="tw-rounded-3xl tw-p-1"
      style="background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
      <div class="tw-w-full tw-bg-white tw-py-8 tw-px-5 sm:tw-px-8 tw-rounded-3xl">
        <ng-container *ngTemplateOutlet="form"></ng-container>
      </div>
    </div>
  </div>

  <!-- Configurable artwork pane (hidden on small screens) -->
  @if(loginImage){
  <div class="tw-hidden lg:tw-flex tw-flex-1 tw-relative tw-bg-cover tw-bg-center"
    [ngStyle]="{ 'background-image': 'url(\'' + loginImage + '\')' }">
    <div class="tw-absolute tw-inset-0"
      style="background: linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 50%, rgba(0,0,0,0.55) 100%);">
    </div>
    @if(loginTitle || loginCaption){
    <div class="tw-relative tw-self-end tw-p-12 tw-text-white">
      @if(loginTitle){<h2 class="tw-text-4xl tw-font-extrabold tw-leading-tight tw-mb-3">{{ loginTitle }}</h2>}
      @if(loginCaption){<p class="tw-text-lg tw-opacity-90 tw-max-w-md">{{ loginCaption }}</p>}
    </div>
    }
  </div>
  }
</div>
}
@else{
@if (mode=='inline') {
<ng-container *ngTemplateOutlet="form"></ng-container>
}
@else if(!current){
<p-button class="tw-hidden lg:tw-block" label="Login or Signup" severity="primary" (click)="displayAuth=true"
  size="small"></p-button>
<i pRipple class="lg:tw-hidden pi pi-sign-in tw-cursor-pointer tw-text-2xl" (click)="displayAuth=true"></i>

<p-dialog [(visible)]="displayAuth" appendTo="body" [style]="{ 'border-radius': '1.5rem'}">
  <ng-template pTemplate="headless">
    <div class="tw-rounded-3xl tw-p-1"
      style="background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
      <div class="tw-w-full tw-bg-white tw-py-8 tw-px-5 sm:tw-px-8 tw-rounded-3xl">
        <ng-container *ngTemplateOutlet="form"></ng-container>
      </div>
    </div>
  </ng-template>
</p-dialog>
}
}
<ng-template #form>
  @if(!isMainComponent && mode!='inline'){
  <i class="pi pi-times tw-absolute tw-top-8 tw-right-8 tw-cursor-pointer" (click)="displayAuth=false"></i>
  }
  <div class="tw-flex tw-flex-col tw-gap-4 tw-max-w-md tw-min-w-80">
    @if(partner?.UI?.Logo) {
    <div class="tw-flex tw-gap-4 tw-justify-center tw-items-center">
      <img [src]="partner.UI.Logo" [alt]="partner.UI?.Title" [title]="partner.UI?.Title"
        class="tw-w-12 tw-aspect-square tw-shadow-md tw-rounded-xl">
      <i class="pi pi-ellipsis-h tw-animate-pulse"></i>
      <img src="assets/images/logo/briteat-logo.svg" alt="BritEat platform" title="BritEat platform"
        class="tw-w-12 tw-aspect-square">
    </div>
    } @else {
    <div class="tw-flex tw-gap-4 tw-justify-center tw-items-center">
      <img src="assets/images/logo/briteat-logo.svg" alt="BritEat platform" class="tw-w-12 tw-right-0">
      <h5 class="tw-left-0">Brit Eat platform</h5>
    </div>
    }

    <div class="p-fluid tw-flex tw-flex-col tw-gap-1">
      <button pButton pRipple [loading]="busy" label="Continue with Google" class="tw-w-full p-button-info"
        icon="pi pi-google" (click)="signInWithGoogle()"></button>
      <!-- <button pButton pRipple [loading]="busy" label="Continue with Facebook" class="tw-w-full" icon="pi pi-facebook"
        (click)="signInWithFacebook()"></button> -->
    </div>

    <div class="tw-w-100 split-line tw-text-gray-500 tw-text-xs">OR</div>

    @if(error){
    <div
      class="text-danger text-center tw-mb-3 tw-font-bold tw-sticky tw-bg-gray-300 tw-rounded-lg tw-p-2 tw-text-sm">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        @switch (error) {
        @case ('reset-email-sent') { If your email address is registered, you will receive an email to reset your
        password. }
        @case ('auth/user-not-found') { User not found. }
        @case ('auth/invalid-email') { Invalid email. }
        @case ('auth/invalid-credential') { Invalid credential. }
        @case ('auth/email-already-in-use') {
        Email already in use.
        If you remember your password <a class="tw-cursor-pointer tw-text-primary" (click)="goto('login')">Log in</a>.
        }
        @default { Error "{{error}}" occurred. }
        }

        @if(page!='forgot'){
        If you're having trouble logging in,
        <a class="font-medium no-underline ml-2 text-right tw-cursor-pointer" style="color: var(--primary-color)"
          (click)="goto('forgot')">reset your password</a>.
        }
        @if (page!='signup') {
        You can also <a class="font-medium no-underline ml-2 text-right tw-cursor-pointer"
          style="color: var(--primary-color)" (click)="goto('signup')">create a new account</a>.}
      </span>
    </div>}

    @switch (page) {
    @case ('signup') {<ng-container *ngTemplateOutlet="signupForm"></ng-container>}
    @case ('forgot') {<ng-container *ngTemplateOutlet="forgotForm"></ng-container>}
    @default {<ng-container *ngTemplateOutlet="loginForm"></ng-container>}
    }
  </div>
</ng-template>

<ng-template #loginForm>
  <span class="p-fluid p-float-label">
    <input pInputText id="username" [(ngModel)]="username" class="tw-w-full" />
    <label for="username">Enter your Email</label>
  </span>

  <span class="p-fluid p-float-label">
    <p-password id="password" [(ngModel)]="password" placeholder="Password" [toggleMask]="true" [feedback]="false"
      styleClass="tw-w-full"></p-password>
    <label for="password">Your password</label>
  </span>

  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
    <p-checkbox label="Remember me" [binary]="true" [(ngModel)]="rememberMe"></p-checkbox>
    <a class="tw-text-xs text-main no-underline tw-m-0 tw-p-0 text-right tw-cursor-pointer "
      (click)="goto('forgot')">Forgot password?</a>
  </div>
  <div class="p-fluid">
    <button pButton pRipple label="Log in" [loading]="busy" class="tw-w-full" (click)="signInWithEmailAndPassword()"
      [disabled]="!username || !password"></button>
    <!-- <button *ngIf="!confirmationResult && !username?.includes('@')" pButton pRipple label="Log in with mobile phone"
      class="tw-w-full" (click)="signInWithMobilePhone()"></button>
    <button *ngIf="confirmationResult" pButton pRipple label="Send Verification Code" class="tw-w-full"
      (click)="confirmMobileCode()"></button> -->
  </div>
  <div class="tw-flex tw-items-center tw-justify-center tw-text-sm" (click)="goto('signup')">
    <span>Don't have an account?&nbsp;</span>
    <a class="font-medium no-underline ml-2 text-right tw-cursor-pointer" style="color: var(--primary-color)">Sign
      up</a>
  </div>
</ng-template>

<ng-template #signupForm>
  <div class="tw-flex tw-text-sm" (click)="goto('login')">
    <span>already have an account?&nbsp;</span>
    <a class="font-medium no-underline ml-2 text-right tw-cursor-pointer" style="color: var(--primary-color)">Log
      in</a>
  </div>

  <span class="p-fluid p-float-label">
    <input pInputText id="name" [(ngModel)]="name" class="tw-w-full" />
    <label for="name">Your Name</label>
  </span>

  <span class="tw-text-sm">This email will be used for communication</span>
  <span class="p-fluid p-float-label">
    <input pInputText id="username" [(ngModel)]="username" class="tw-w-full" />
    <label for="username">Your email</label>
  </span>

  <span class="p-fluid p-float-label">
    <p-password id="password" [(ngModel)]="password" placeholder="Password" [toggleMask]="true"
      styleClass="tw-w-full"></p-password>
    <label for="password">Your password</label>
  </span>

  <div class="p-fluid">
    <button pButton pRipple label="Create account" [loading]="busy" class="tw-w-full"
      (click)="signUpWithEmailAndPassword()" [disabled]="!username || !password"></button>
  </div>
</ng-template>

<ng-template #forgotForm>
  <div class="tw-flex tw-text-sm" (click)="goto('login')">
    <span>remembered your password?&nbsp;</span>
    <a class="font-medium no-underline ml-2 text-right tw-cursor-pointer" style="color: var(--primary-color)">Log
      in</a>
  </div>

  <span class="p-fluid p-float-label">
    <input pInputText id="username" [(ngModel)]="username" class="tw-w-full" />
    <label for="username">Your email</label>
  </span>

  <div class="p-fluid">
    <button pButton pRipple label="Reset password" [loading]="busy" class="tw-w-full" (click)="resetPassword()"
      [disabled]="!username"></button>
  </div>
</ng-template>